export default __webpack_public_path__ + "static/media/listing-04.c2b24ee6.jpg";